import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "report-problem-container detail-popup" }
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Report a Problem", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "What Happened?", -1 /* HOISTED */)
const _hoisted_5 = {
  key: 0,
  class: "checkboxes"
}
const _hoisted_6 = { class: "checkbox-container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "description-container" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Client didn't attend the meeting")
], -1 /* HOISTED */)
const _hoisted_8 = { class: "checkbox-container" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "description-container" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "I missed the meeting")
], -1 /* HOISTED */)
const _hoisted_10 = {
  key: 1,
  class: "checkboxes"
}
const _hoisted_11 = { class: "checkbox-container" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "description-container" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "I can't attend the meeting")
], -1 /* HOISTED */)
const _hoisted_13 = { class: "checkbox-container" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "description-container" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "I don't need the meeting anymore")
], -1 /* HOISTED */)
const _hoisted_15 = { class: "notes" }
const _hoisted_16 = { class: "checkboxes send-copy" }
const _hoisted_17 = { class: "checkbox-container" }
const _hoisted_18 = { class: "description-container" }
const _hoisted_19 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.loading)
      ? (_openBlock(), _createBlock($setup["Loader"], {
          key: 0,
          class: "loader",
          "full-screen": true
        }))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["CloseButton"], { onClick: $setup.deepClosePopup }),
    _createVNode($setup["DetailsHeader"], {
      meetingMoment: $setup.meetingMoment,
      name: $setup.name
    }, null, 8 /* PROPS */, ["meetingMoment", "name"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createCommentVNode("Don't Change These checkbox options yet, apparently we're waiting on the opt team for what they should be"),
      ($setup.Meetings.canMeetingBeConfirmed($props.selectedMeeting))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode($setup["VCheckbox"], {
                class: "checkbox",
                modelValue: $setup.clientDidntAttend,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.clientDidntAttend) = $event))
              }, null, 8 /* PROPS */, ["modelValue"]),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode($setup["VCheckbox"], {
                class: "checkbox",
                modelValue: $setup.userDidntAttend,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.userDidntAttend) = $event))
              }, null, 8 /* PROPS */, ["modelValue"]),
              _hoisted_9
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode($setup["VCheckbox"], {
                class: "checkbox",
                modelValue: $setup.clientDidntAttend,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.clientDidntAttend) = $event))
              }, null, 8 /* PROPS */, ["modelValue"]),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode($setup["VCheckbox"], {
                class: "checkbox",
                modelValue: $setup.userDidntAttend,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.userDidntAttend) = $event))
              }, null, 8 /* PROPS */, ["modelValue"]),
              _hoisted_14
            ])
          ])),
      _createElementVNode("div", _hoisted_15, [
        _createVNode($setup["TextField"], {
          class: "note what-happned-note",
          label: "Details",
          modelValue: $setup.message,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.message) = $event))
        }, null, 8 /* PROPS */, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode($setup["VCheckbox"], {
            class: "checkbox",
            modelValue: $setup.sendCopy,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.sendCopy) = $event))
          }, null, 8 /* PROPS */, ["modelValue"]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("span", _hoisted_19, "Send a copy to " + _toDisplayString($setup.name), 1 /* TEXT */)
          ])
        ])
      ]),
      _createElementVNode("button", {
        class: "outline reschedule",
        onClick: $setup.reschedule
      }, "Reschedule Instead")
    ]),
    _createElementVNode("div", { class: "button-container horizontal" }, [
      _createElementVNode("button", {
        class: "borderless back",
        onClick: $setup.closePopup
      }, "Back"),
      _createElementVNode("button", {
        class: "primary submit",
        onClick: $setup.reportProblem
      }, "Submit")
    ])
  ]))
}